function setCookie(name, value, days) {
    const date = new Date();

    date.setTime(
        date.getTime() + days * 24 * 60 * 60 * 1000
    );

    const expires = 'expires=' + date.toUTCString();

    document.cookie =
        `${name}=${value};` +
        `${expires};` +
        `path=/;` +
        `domain=.clivechristian.com;` +
        `SameSite=Lax;` +
        `Secure`;
}

function getCookie(name) {
    const nameEQ = name + '=';
    const cookies = document.cookie.split(';');

    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();

        if (cookie.indexOf(nameEQ) === 0) {
            return decodeURIComponent(
                cookie.substring(nameEQ.length)
            );
        }
    }

    return null;
}

function toggleElements() {
    var elements = document.querySelectorAll(
        '.form__select.select.choices__input'
    );

    elements.forEach(function(element) {
        if (
            !element.hasAttribute('data-language') ||
            element.dataset.language === 'en' ||
            element === elements[0]
        ) {
            return;
        }

        var wrapper = element.parentElement.parentElement;

        wrapper.style.display =
            wrapper.style.display === 'none' ? '' : 'none';
    });
}


document.addEventListener('DOMContentLoaded', function () {
    var regionSelect = document.querySelector(
        '.form__select[name="region"]'
    );

    var changeUrlButton = document.getElementById('changeUrl');

    function updateCitySelects(regionValue) {
        var citySelects = document.querySelectorAll(
            '.form__select.select.choices__input:not([name="region"])'
        );

        // Сначала скрываем все списки городов
        citySelects.forEach(function (element) {
            var wrapper = element.parentElement?.parentElement;

            if (wrapper) {
                wrapper.style.display = 'none';
            }
        });

        // Показываем города выбранного региона
        var citySelectsToShow = document.querySelectorAll(
            '.form__select.select.choices__input[data-language~="' +
            regionValue +
            '"]'
        );

        citySelectsToShow.forEach(function (element) {
            var wrapper = element.parentElement?.parentElement;

            if (wrapper) {
                wrapper.style.display = '';
            }
        });
    }

    if (!regionSelect) {
        return;
    }

    /*
     * Восстанавливаем выбранную страну.
     */
    var selectedCountry = getCookie('selectedCountry');
    var options = Array.from(regionSelect.options);

    var selectedOption = options.find(function (option) {
        return option.textContent.trim() === selectedCountry;
    });

    /*
     * На EU-домене Italy используется только по умолчанию.
     * Если в cookie Germany, France и т. д., страна сохраняется.
     */
    if (
        window.location.hostname === 'eu.clivechristian.com' &&
        (
            !selectedOption ||
            selectedCountry === 'United Kingdom' ||
            selectedCountry === 'United States'
        )
    ) {
        selectedCountry = 'Italy';

        selectedOption = options.find(function (option) {
            return option.textContent.trim() === selectedCountry;
        });

        setCookie('selectedCountry', selectedCountry, 7);
    }

    /*
     * На основном домене выбираем UK.
     */
    if (window.location.hostname === 'clivechristian.com') {
        selectedCountry = 'United Kingdom';

        selectedOption = options.find(function (option) {
            return option.textContent.trim() === selectedCountry;
        });

        setCookie('selectedCountry', selectedCountry, 7);
    }

    /*
     * На US-домене выбираем US.
     */
    if (window.location.hostname === 'us.clivechristian.com') {
        selectedCountry = 'United States';

        selectedOption = options.find(function (option) {
            return option.textContent.trim() === selectedCountry;
        });

        setCookie('selectedCountry', selectedCountry, 7);
    }

    if (selectedOption) {
        regionSelect.value = selectedOption.value;
        selectedOption.selected = true;

        var countryChoicesText = document.querySelector(
            '.choices__list--single .choices__item.choices__item--selectable'
        );

        if (countryChoicesText) {
            countryChoicesText.textContent =
                selectedOption.textContent.trim();
        }

        // Важно: сразу показываем города выбранной страны
        updateCitySelects(selectedOption.value);
    }

    /*
     * При ручной смене страны переключаем города.
     */
    regionSelect.addEventListener('change', function () {
        var option = regionSelect.options[regionSelect.selectedIndex];

        if (!option) {
            return;
        }

        updateCitySelects(option.value);
    });

    /*
     * Переход на нужный домен.
     */
    if (changeUrlButton) {
        changeUrlButton.addEventListener('click', function () {
            var option = regionSelect.options[regionSelect.selectedIndex];

            if (!option) {
                return;
            }

            var country = option.textContent.trim();

            setCookie('selectedCountry', country, 7);

            if (country === 'United Kingdom') {
                window.location.href = 'https://clivechristian.com/';
            } else if (country === 'United States') {
                window.location.href = 'https://us.clivechristian.com/';
            } else {
                window.location.href = 'https://eu.clivechristian.com/';
            }
        });
    }
});